import type { OrganizationSummary, OrgHeadline } from '@/api/types';
import type { Tone } from '@/design-system';

/** The list's «Статус» pill (design: o.st / o.stT). */
export const HEADLINE_TONE: Record<OrgHeadline, Tone> = {
  production: 'ok',
  demo: 'warn',
  awaiting_dns: 'warn',
  draft: 'mute',
  build_error: 'err',
  landing: 'ok',
  archived: 'mute',
  active: 'ok',
  trial: 'mute',
};

/** The API's headline when it has one (GAP); until then it is read from the status and the site count. */
export function headlineOf(o: Pick<OrganizationSummary, 'headline' | 'status' | 'sites_count'>): OrgHeadline {
  if (o.headline) return o.headline;
  if (o.status === 'archived') return 'archived';
  if (!o.sites_count) return 'draft';
  return o.status === 'trial' ? 'trial' : 'active';
}
